import {
  HouseExtension,
  ProductRowDetail,
  ProductRowDetailValue,
  ProductRowDetailValueInline,
} from "./styled";

import { StyledRow } from "App/global-style";
import React from "react";
import { ProductDetail } from "../interface";

interface Props {
  readonly detail: ProductDetail;
  readonly productText: any;
  readonly lang: string;
}

export const ProductDetailsTableRow = ({
  detail,
  productText,
  lang,
}: Props): React.ReactElement | null => {
  if (!detail.hidden) {
    const text: Record<string, string> = productText.details[detail.name];
    const textDetail: string = text ? text[lang] : detail.name;

    if (
      detail.name === "additionalBuildings" &&
      typeof detail.value === "object"
    ) {
      return (
        <HouseExtension>
          <p>{textDetail}</p>
          <ProductRowDetailValueInline>
            {detail.value ?? "??"}
          </ProductRowDetailValueInline>
        </HouseExtension>
      );
    }

    return (
      <StyledRow className={detail.suppressHJ ? "data-hj-suppress" : ""}>
        <ProductRowDetail>
          <p>{textDetail}</p>
        </ProductRowDetail>
        <ProductRowDetailValue>{detail.value ?? "??"}</ProductRowDetailValue>
      </StyledRow>
    );
  }

  return null;
};
